import { ValidationIssue, ValidationIssueReason } from 'src/app/services/report-template-validation.service';

export function mergeUnresolvedIssues(existing: ValidationIssue[], unresolvedPaths: string[]): ValidationIssue[] {
  const known = new Set(existing.map(issue => issue.path));
  const added = unresolvedPaths
    .filter(path => !known.has(path))
    .map((path): ValidationIssue => ({ path, reason: ValidationIssueReason.UnresolvedRaw }));
  return [...existing, ...added];
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function carryForwardUnresolvedIssues(previous: ValidationIssue[], html: string): string[] {
  return previous
    .filter(issue => issue.reason === ValidationIssueReason.UnresolvedRaw)
    .map(issue => issue.path)
    .filter(path => new RegExp(`(^|[^\\w.])${escapeRegExp(path)}(?![\\w.])`).test(html));
}
